import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import __ from 'utils/i18n';

const outcomeClass = {
  success: 'success',
  skipped: 'warning',
  error: 'danger',
};

const normalizeId = (id) => (id == null ? '' : String(id).toLowerCase());

export const BulkActionResultsModal = ({
  showModal = false,
  hideModal,
  result,
  emailBySubscriptionId = {},
}) => {
  if (!result) return null;

  const resolveLabel = (item) => {
    const id = item.subscriptionId;
    return item.email
      || emailBySubscriptionId[id]
      || emailBySubscriptionId[String(id)]
      || emailBySubscriptionId[normalizeId(id)]
      || null;
  };

  const resolveReason = (item) => {
    if (!item.reason) return null;
    if (item.errorCode === 'SUBSCRIPTION_NOT_FOUND') {
      return __('dashboard.sections.recurringPayments.subscribers.bulk.reasons.subscriptionNotFound');
    }
    return item.reason;
  };

  return (
    <Modal
      isOpen={showModal}
      toggle={hideModal}
      className="dashboard-modal"
      zIndex={1000000}
      size="lg"
    >
      <ModalHeader toggle={hideModal}>
        {__('dashboard.sections.recurringPayments.subscribers.bulk.resultsTitle')}
      </ModalHeader>
      <ModalBody>
        <div className="recurring-payments-text-wrap">
          <p className="mb-3">
            {__('dashboard.sections.recurringPayments.subscribers.bulk.resultsSummary', {
              succeeded: result.succeeded,
              skipped: result.skipped,
              failed: result.failed,
            })}
          </p>
          {result.truncated && (
            <p className="text-muted mb-3">
              {__('dashboard.sections.recurringPayments.subscribers.bulk.resultsTruncated', {
                processed: result.processed,
                total: result.totalMatched,
              })}
            </p>
          )}
          <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
            {(result.results || []).map((item) => {
              const label = resolveLabel(item);
              const reason = item.outcome !== 'success' ? resolveReason(item) : null;
              return (
                <div
                  key={item.subscriptionId}
                  className="d-flex align-items-start justify-content-between py-2 border-bottom"
                >
                  <div>
                    <div>
                      {label
                        || __('dashboard.sections.recurringPayments.subscribers.bulk.unknownSubscriber')}
                    </div>
                    {reason && (
                      <small className="text-muted">{reason}</small>
                    )}
                  </div>
                  <span
                    className={`badge badge-${outcomeClass[item.outcome] || 'secondary'} ml-2 bulk-action-result-badge`}
                  >
                    {__(`dashboard.sections.recurringPayments.subscribers.bulk.outcomes.${item.outcome}`)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
